export default __webpack_public_path__ + "static/inventory-optimisation-1--mobile-354c00249fd8929b83fa4934f309cd0e.webp";